<template>
  <section 
    class="mt-2" 
    v-if="rfq && (estimationHasWall || estimationHasRailing)">

    <h1>Summary of Tax Incentives</h1>
    <hr class="h1-underline"/>

    <div class="content--nobreak">
      <template v-if="hasMpaPrice">
        <h2>
          Summary of Possible Tax Incentives Under MPA
        </h2>
        <possible-tax-incentives
          :estimation="estimation"
          :has-mpa-price="true"
          :has-dpa-price="false"/>
      </template>

      <template v-if="hasDpaPrice">
        <h2>
          Summary of Possible Tax Incentives Under DPA
        </h2>
        <possible-tax-incentives
          :estimation="estimation"
          :has-mpa-price="false"
          :has-dpa-price="true"/>
      </template>

      <div class="mb-3" v-if="taxIncentiveDesc" v-html="taxIncentiveDesc">
      </div>

      <div class="mb-3" v-if="summaryTaxIncentiveDesc" v-html="summaryTaxIncentiveDesc">
      </div>

      <div class="help">
        Please Note: The above calculations are the results of our research into 
        the facts as understood by us. It should be used by the client to 
        independently make decisions and should not be considered conclusion, 
        decision, or report.
      </div>
    </div>
    
  </section>
</template>

<script>
import PossibleTaxIncentives from '@/components/proposalmaker/PossibleTaxIncentives'

export default {
  props: {
    taxIncentiveDesc: {
      type: [String, Number],
      default: null
    },
    summaryTaxIncentiveDesc: {
      type: [String, Number],
      default: null
    },
    rfq: {
      type: Object
    },
    hasMpaPrice: {
      type: Boolean
    },
    hasDpaPrice: {
      type: Boolean
    }
  },
  components: { PossibleTaxIncentives },
  computed: {
    estimation({ rfq }) {
      return rfq.c_estimation ? rfq.c_estimation : rfq.estimation;
    },
    estimationHasWall({ estimation }) {
      return Object.keys(estimation.estimation_summary).includes('solar_wall_active');
    },
    estimationHasRailing({ estimation }) {
      return estimation.estimation_summary.summary.filter(
        d => d.pricing_summary.includes('railing')
      ).length > 0;
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/styles/flexbox.scss';
</style>
